import { render, staticRenderFns } from "./NumberSlot.vue?vue&type=template&id=1a61c6ec&"
import script from "./NumberSlot.vue?vue&type=script&lang=ts&"
export * from "./NumberSlot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports